import type { ReactNode } from 'react'

import { ValidatedForm } from '../inputs'
import { RadioItem } from './RadioField'

type RadioButtonFormProps = {
  checked: boolean
  children: ReactNode
  id: string
  label: string
  onChange: () => void
  onValidSubmit?: () => void
}

const RadioButtonForm = ({
  checked,
  children,
  id,
  label,
  onChange,
  onValidSubmit,
}: RadioButtonFormProps) => {
  return (
    <>
      <RadioItem
        name=""
        value=""
        checked={checked}
        onChange={onChange}
        label={label}
        id={id}
      />

      {checked && (
        <ValidatedForm className="form-row mb-2" onValidSubmit={onValidSubmit}>
          {children}
        </ValidatedForm>
      )}
    </>
  )
}

export default RadioButtonForm
